module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/particular05-02ff9b762181148d699577bac0eb7ad0.png";